<template>
  <div class="p-4">
    <el-form
      label-position="left"
      size="medium"
      label-width="80px"
      :model="formData"
      :rules="currentRules"
      ref="form"
    >
      <el-form-item
        label="广告账户"
        prop="accountId"
      >
        <account :currentAccount="createAdAccount"></account>
      </el-form-item>
      <el-form-item prop="campaignTraceConfigData">
        <campaignTraceConfig
          :value="formData.campaignTraceConfigData"
          @input="changeCampaignTraceConfig"
        />
      </el-form-item>
      <el-form-item
        label="推广连接"
        prop="promotionLink"
      >
        <el-row>
          <el-col :span="18">
            <el-input
              v-model="formData.promotionLink"
              @blur="onChangePromotionLink"
              v-loading="promotionLinkLoading"
              @keyup.enter.native="
                (e) => {
                  e.target.blur();
                }
              "
            ></el-input>
          </el-col>
          <el-col
            :span="6"
            class="pl-2 flex"
          >
            <el-tooltip
              content="点击一键创建会根据您输入的链接获取搜索广告所需要的信息填充表单"
              placement="top"
            >
              <el-button
                type="primary"
                size="small"
                :loading="oneClickLoading"
                @mousedown.native="skipPromoteInfoCall = true"
                @click="handleOneClickCreate"
                >一键创建</el-button
              >
            </el-tooltip>
            <el-button
              type="text"
              @click="openLink"
              class="w-[80px]"
              >预览</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item
        label="商品id"
        prop="sale"
      >
        <sale :sale-info="formData.sale"></sale>
      </el-form-item>
      <el-form-item
        label="站点信息"
        prop="site"
      >
        <site
          v-model="formData.site"
          disabled
        ></site>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import account from '@/views/google/create/components/campaignInfo/components/account.vue';
import campaignBudget from '@/views/google/create/components/campaignInfo/components/campaignBudget.vue';
import campaignTraceConfig from '@/views/google/create/components/campaignInfo/components/campaignTraceConfig.vue';
import sale from '@/components/create/sale.vue';
import site from '@/components/create/site.vue';
import { rules, regUrl } from '@/views/google/create/components/campaignInfo/index';
import { promoteInfo, createSearchAdByUrl } from '@/api/google/create';
import { checkGoogleSaleRisk, googleAccountId, googleAccountName } from '@/components/google/riskLevelCheck';
export default {
  name: 'PromotionLink',
  props: {
    createAdAccount: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      promotionLinkLoading: false,
      oneClickLoading: false,
      riskCheckedKey: '',
      riskCheckSeq: 0,
      skipPromoteInfoCall: false, // 一键投放后跳过 promoteInfo 接口调用
      formData: {
        campaignTraceConfigData: {},
      },
    };
  },
  components: {
    account,
    campaignBudget,
    campaignTraceConfig,
    sale,
    site,
  },

  computed: {
    saleRiskToken() {
      const saleId = this.formData.sale && this.formData.sale.saleId;
      return googleAccountId(this.createAdAccount) + '\0' + (saleId == null ? '' : saleId);
    },
    currentRules() {
      return {
        ...rules,
        campaignTraceConfigData: [
          {
            required: this.formData.campaignTraceConfigData?.enable,
            message: '请选择推广渠道',
            trigger: 'change',
          },
        ],
      };
    },
  },
  methods: {
    onChangePromotionLink() {
      if (!this.formData.promotionLink || !this.formData.promotionLink.trim()) {
        this.$set(this.formData, 'sale', null);
        this.$set(this.formData, 'site', null);
      }
      // 一键投放后跳过 promoteInfo 接口调用
      if (this.skipPromoteInfoCall) {
        this.skipPromoteInfoCall = false;
        return;
      }
      let params = {
        promotionLink: this.formData.promotionLink?.trim(),
        utmSourceConfig: this.createAdAccount.utmSourceConfig,
      };
      if (!regUrl.test(this.formData.promotionLink)) {
        return;
      }

      this.promotionLinkLoading = true;
      this.$set(this.formData, 'sale', null);
      this.$set(this.formData, 'site', null);
      promoteInfo(params)
        .then((res) => {
          if (res.code == 0) {
            this.$set(this.formData, 'site', { ...res.data.site, name: res.data.site.domain });
            this.$set(this.formData, 'sale', { ...res.data.sale, id: res.data.sale.saleId });
            this.$set(this.formData, 'utmSourceConfig', res.data.utmSourceConfig);
            this.$set(this.formData, 'languageId', res.data.apiLanguageId);
            this.$set(this.formData, 'locationId', res.data.apiLocationId);
            this.$set(this.formData, 'promotionLink', res.data.promotionLink);
          } else {
            this.$set(this.formData, 'sale', null);
            this.$set(this.formData, 'site', null);
            this.$set(this.formData, 'utmSourceConfig', null);
            this.$set(this.formData, 'languageId', null);
            this.$set(this.formData, 'locationId', null);
          }
          if (this.value.promoteInfo.promotionLink != this.formData.promotionLink) {
            this.$emit('changePromotionLink', this.formData.promotionLink);
          }
          this.onChange();
        })
        .finally(() => {
          this.promotionLinkLoading = false;
        });
    },
    // 一键投放
    async handleOneClickCreate() {
      if (!this.formData.promotionLink || !this.formData.promotionLink.trim()) {
        this.$message.warning('请先输入推广链接');
        return;
      }
      if (!regUrl.test(this.formData.promotionLink)) {
        this.$message.warning('请输入正确的链接格式');
        return;
      }
      if (!this.createAdAccount.id) {
        this.$message.warning('请先选择广告账户');
        return;
      }
      this.oneClickLoading = true;
      try {
        const res = await createSearchAdByUrl({
          promotionLink: this.formData.promotionLink.trim(),
          accountId: this.createAdAccount.id,
        });
        if (res.code == 0 && res.data) {
          this.$message.success('获取投放信息成功');
          // 设置标记，跳过下一次 promoteInfo 接口调用
          this.skipPromoteInfoCall = true;
          // 将返回的数据传递给父组件进行表单回填
          this.$emit('oneClickFill', res.data);
        } else {
          this.$message.error(res.comment || '获取投放信息失败');
        }
      } catch (error) {
        this.$message.error('获取投放信息失败');
      } finally {
        this.oneClickLoading = false;
      }
    },
    changeCampaignTraceConfig(val) {
      console.log(val, 'val');
      this.campaignTraceConfigData = val;
      this.formData.campaignTraceConfig = val;
      console.log(this.campaignTraceConfigData);
      //   数据改变之后再往外抛出数据，防止抛出的数据是修改前的数据
      this.$nextTick(() => {
        this.onChange();
      });
      //   this.$emit('changeCampaignTraceConfig', val);
    },
    // 打开链接验证链接是否能打开
    openLink() {
      if (!this.formData.promotionLink) return;
      window.open(this.formData.promotionLink);
    },
    clearResolvedPromotion() {
      this.$set(this.formData, 'sale', null);
      this.$set(this.formData, 'site', null);
      this.$set(this.formData, 'promotionLink', '');
      this.$set(this.formData, 'utmSourceConfig', null);
      this.onChange();
    },
    checkCurrentSaleRisk() {
      const sale = this.formData.sale;
      checkGoogleSaleRisk(this, {
        saleId: sale && sale.saleId,
        accountId: googleAccountId(this.createAdAccount),
        accountName: googleAccountName(this.createAdAccount),
        stillCurrent: (saleId, accountId) => {
          const current = this.formData.sale && this.formData.sale.saleId;
          return String(current) === String(saleId) && googleAccountId(this.createAdAccount) === accountId;
        },
        onCancel: () => this.clearResolvedPromotion(),
      });
    },
    onChange() {
      const { promotionLink, sale, site, utmSourceConfig, languageId, locationId } = this.formData;
      const newValue = {
        ...this.value,
        campaignTraceConfig: { ...this.campaignTraceConfigData },
        promoteInfo: {
          promotionLink,
          sale,
          site,
          utmSourceConfig,
        },
      };
      console.log(newValue);
      this.$emit('input', {
        ...newValue,
      });
      this.$emit('change', {
        ...newValue,
      });
    },
    // 初始化数据
    initData() {
      const { promoteInfo = {} } = this.value;
      this.formData = {
        accountId: this.createAdAccount.id,
        promotionLink: promoteInfo.promotionLink,
        sale: promoteInfo.sale,
        site: promoteInfo.site,
        utmSourceConfig: promoteInfo.utmSourceConfig,
      };
      this.campaignTraceConfigData = { ...this.value.campaignTraceConfig };
    },
    // 对外提供的验证
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, errors) => {
          console.log(valid, 'valid');
          if (valid) {
            resolve(true);
          } else {
            const errorMessages = Object.values(errors)
              .flat()
              .map((error) => error.message);
            reject(errorMessages);
          }
        });
      });
    },
  },
  watch: {
    saleRiskToken() {
      this.checkCurrentSaleRisk();
    },
    value: {
      handler(val) {
        this.initData();
      },
      deep: true,
    },
  },
  created() {
    this.initData();
  },
};
</script>
